const variants = {
  transparent: {
    backgroundColor: "transparent",
    color: "primary-white",
  },
  white: {
    backgroundColor: "primary-white",
    color: "secondary-nav-blue",
    boxShadow: "default",
  },
};

export default variants;
